import { message } from "antd";
import api from "@/api";
import store from "@/stores";
import dataJson from "@/../public/data.json";
import type { FormInstance } from "antd";
import { removeAuthToken } from "@kaihong/utils/lib/khAuthToken";
import { PROCESS_ENV_NODE, publicPath } from "./base";
import { numberDomainReg } from "./constant";

const { app_detail } = dataJson;

const cryptoJs = require("crypto-js");
type keys = "y+" | "M+" | "d+" | "H+" | "m+" | "s+" | "W+";
type Dukey = {
  [key in keys]: number;
};

export const format = (date: Date, fmt: string) => {
  let ret;
  const o: Dukey = {
    "y+": date.getFullYear(),
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "H+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "W+": date.getDay(),
  };
  // 类型断言
  (Object.keys(o) as (keyof Dukey)[]).forEach((key) => {
    ret = new RegExp("(" + key + ")").exec(fmt);
    if (ret) {
      let str = o[key].toString();
      const len = ret[1].length;
      if (len !== 1 && len > str.length) {
        str = addZero(str, len - str.length);
      }
      fmt = fmt.replace(ret[1], str);
    }
  });
  return fmt;
};

export const addZero = (str: string, len: number) => {
  return `${new Array(len).fill(0).join("")}${str}`;
};

export const getImageBase64 = (imgUrl: string) => {
  return new Promise((resolve, reject) => {
    window.URL = window.URL || window.webkitURL;
    const xhr = new XMLHttpRequest();
    xhr.open("get", imgUrl, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (this.status === 200) {
        //得到一个blob对象
        const blob = this.response;
        // console.log("blob", blob);
        // 至关重要
        const oFileReader = new FileReader();
        oFileReader.onloadend = function (e: any) {
          // 此处拿到的已经是base64的图片了,可以赋值做相应的处理
          // console.log(e.target.result);
          resolve(e.target.result);
        };
        oFileReader.readAsDataURL(blob);
      }
    };
    xhr.send();
  });
};

export const sliceTopic = (topic: string) => {
  const reportIndex = topic.indexOf("/message/property/report");
  topic = topic.slice(0, reportIndex);
  const lastIndex = topic.lastIndexOf("/") + 1;
  topic = topic.slice(lastIndex);

  const typeIndex = topic.lastIndexOf("_") + 1;
  const typeStr = topic.slice(0, typeIndex);
  const serialNumber = parseInt(topic.slice(typeIndex));
  return {
    topic,
    typeStr,
    serialNumber,
  };
};

// 设置元素全屏
export const setFullScreen = (eleId: string) => {
  const video: any = document.getElementById(eleId);
  if (!video) return;
  if (video.requestFullscreen) {
    video.requestFullscreen();
  } else if (video.msRequestFullscreen) {
    video.msRequestFullscreen();
  } else if (video.mozRequestFullScreen) {
    video.mozRequestFullScreen();
  } else if (video.webkitRequestFullscreen) {
    video.webkitRequestFullscreen();
  }
};

const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2;
  if (t < 1) {
    return (c / 2) * t * t + b;
  }
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

// requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
const requestAnimFrame = (function () {
  return (
    window.requestAnimationFrame ||
    (window as any).webkitRequestAnimationFrame ||
    (window as any).mozRequestAnimationFrame ||
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    }
  );
})();
export const scrollTo = (dom: any, to: number, duration = 300, callback?: any) => {
  const start = dom.scrollTop;
  const change = to - start;
  const increment = 20;
  let currentTime = 0;
  duration = typeof duration === "undefined" ? 500 : duration;
  const animateScroll = function () {
    // increment the time
    currentTime += increment;
    // find the value with the quadratic in-out easing function
    const val = easeInOutQuad(currentTime, start, change, duration);
    // move the document.body
    dom.scrollTop = val;
    // do the animation unless its over
    if (currentTime < duration) {
      requestAnimFrame(animateScroll);
    } else {
      if (callback && typeof callback === "function") {
        // the animation is done so lets callback
        callback();
      }
    }
  };
  animateScroll();
};

/*
 * 参数 data
 * domId 禁止滚动的容器
 */
export const disableScroll = (domId: string) => {
  const scrollTopVal = document.documentElement.scrollTop || document.body.scrollTop;
  // 禁止滑动
  const selectId = domId || "app";
  const selectDom = document.getElementById(selectId);
  if (selectDom && selectDom.style.position !== "fixed") {
    selectDom.style.position = "fixed";
    selectDom.style.top = "-" + scrollTopVal + "px";
    selectDom.style.width = "100%";
    selectDom.style.overflow = "hidden";
  }
};

export const enableScroll = (domId: string) => {
  /** *取消滑动限制***/
  const selectId = domId || "app";
  const selectDom = document.getElementById(selectId);
  if (selectDom && selectDom.style.position === "fixed") {
    const scrollVal = Math.abs(parseFloat(selectDom.style.top));
    selectDom.style.position = "";
    selectDom.style.overflow = "";
    selectDom.style.top = "";
    if (document.body) {
      document.body.scrollTop = scrollVal;
    }
    if (document.documentElement) {
      document.documentElement.scrollTop = scrollVal;
    }
  }
};

export const hmacSHA256 = (str: string, key: string) => {
  const strVal = cryptoJs.enc.Utf8.parse(str);
  const hmac = cryptoJs.HmacSHA256(key, strVal).toString().toUpperCase();
  return hmac;
};

export const changeSize = (num: number) => {
  const limit = Number(num);
  let size = "";
  if (limit < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (limit / 1024).toFixed(2) + "KB";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }

  const sizeStr = size + ""; //转成字符串
  const index = sizeStr.indexOf("."); //获取小数点处的索引
  const dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
  if (dou == "00") {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
  }
  return size;
};

// 递归查找某个对象 {数组、查找对象得关键字、根据哪个属性查找、子数组的属性名}
export const findDeep = (array: any[], key: any, attr = "value", child = "children") => {
  for (let index = 0; index < array?.length; index++) {
    const element = array[index];

    if (element[attr] === key) {
      return element;
    } else if (element[child]?.length) {
      const item = findDeep(element[child], key, attr, child);

      if (item !== null) {
        return element; // 如果在子路由中找到了目标路由，则返回该路由对象
      }
    }
  }
  return null;
};

// 获取上架审核应用详情
export const getReleaseDetail = async (
  type: string | number | undefined,
  id: string | number | undefined,
  cb?: any,
  onTampered?: (errorInfo: any) => void
) => {
  const typeObj: any = app_detail.type_obj;
  const typeItem = typeObj[getType(type!)];

  try {
    const res: any = await api[typeItem.detailApi]({ id });
    if (isTamperedError(undefined, res)) {
      store.dispatch({
        type: "setReleaseDetail",
        payload: null,
      });
      message.error(res?.msg || "数据完整性校验失败，数据疑似被篡改");
      if (typeof onTampered === "function") {
        onTampered(res);
      }
      return;
    }
    store.dispatch({
      type: "setReleaseDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setReleaseDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
    if (isTamperedError(errorInfo) && typeof onTampered === "function") {
      onTampered(errorInfo);
    }
  }
};

// js判断两个数组内容是否相等
export const arraysAreEqual = (arr1: any[], arr2: any[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
};

// 对象数组扁平化
export const flattenObjectArray = (objectArray: any[], childrenKey = "children") => {
  let flatArr: any[] = [];
  objectArray.forEach((item) => {
    flatArr.push(item); // 首先添加当前项
    if (item[childrenKey]) {
      // 如果当前项有子项，递归处理子项
      flatArr = flatArr.concat(flattenObjectArray(item[childrenKey], childrenKey)); // 递归调用并连接结果
      // delete item[childrenKey]; // 可选：删除子项属性，以保持扁平化结构清晰
    }
  });
  return flatArr;
};

// 获取业务规则详情
export const getRulesDetail = async (id: string | number | undefined, cb?: any) => {
  try {
    const res: any = await api.getRuleDetailApi({ id });
    store.dispatch({
      type: "setRulesDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setRulesDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
  }
};

/**
 * 判断是否为数据被篡改
 * 1. HTTP 状态码 500，且错误信息包含「篡改」
 * 2. HTTP 200 但业务 code === 500，且 msg 包含「篡改」
 */
export const isTamperedError = (error?: any, response?: any): boolean => {
  const hasTamperKeyword = (msg: any) => String(msg ?? "").includes("篡改");

  const httpStatus = error?.response?.status;
  if (httpStatus === 500) {
    const data = error?.response?.data;
    const errorMsg =
      typeof data === "string" ? data : data?.msg || data?.message || error?.message || "";
    if (hasTamperKeyword(errorMsg)) {
      return true;
    }
  }

  if (response) {
    const responseMsg = response?.msg || response?.message || "";
    if (response?.code === 500 && hasTamperKeyword(responseMsg)) {
      return true;
    }
  }

  return false;
};

// 获取超级设备模板详情
export const getSuperDeviceTemplateDetail = async (
  id: string | number | undefined,
  cb?: any,
  onTampered?: (errorInfo: any) => void
) => {
  try {
    const res: any = await api.getSuperDeviceDetailApi({ id });
    if (isTamperedError(undefined, res)) {
      store.dispatch({
        type: "setSuperDeviceTemplateDetail",
        payload: null,
      });
      message.error(res?.msg || "数据完整性校验失败，数据疑似被篡改");
      if (typeof onTampered === "function") {
        onTampered(res);
      }
      return;
    }
    store.dispatch({
      type: "setSuperDeviceTemplateDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setSuperDeviceTemplateDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
    if (isTamperedError(errorInfo) && typeof onTampered === "function") {
      onTampered(errorInfo);
      return;
    }
  }
};

// 获取AI应用详情
export const getAiModelDetail = async (
  id: string | number | undefined,
  cb?: any,
  onTampered?: (errorInfo: any) => void
) => {
  try {
    const res: any = await api.getAiModelDetail({ id });
    if (isTamperedError(undefined, res)) {
      store.dispatch({
        type: "setAiModelDetail",
        payload: null,
      });
      message.error(res?.msg || "数据完整性校验失败，数据疑似被篡改");
      if (typeof onTampered === "function") {
        onTampered(res);
      }
      return;
    }
    store.dispatch({
      type: "setAiModelDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setAiModelDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
    if (isTamperedError(errorInfo) && typeof onTampered === "function") {
      onTampered(errorInfo);
    }
  }
};

// 获取智能体详情
export const getAgentDetail = async (id: string | number | undefined, cb?: any) => {
  try {
    const res: any = await api.getAgentDetail({ id });
    store.dispatch({
      type: "setAgentDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setAgentDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
  }
};

// 获取解决方案详情
export const getSolutionDetail = async (obj: any, cb?: any) => {
  try {
    console.log(obj, "333");
    const res: any = await api.getSolutionDetail(obj); // 解决方案详情
    store.dispatch({
      type: "setSolutionDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    message.error(errorInfo?.response?.data?.msg || "出错了！");
  }
};

// 获取设备插件详情
export const getDevicePluginDetail = async (id: string | number | undefined, cb?: any) => {
  try {
    const res: any = await api.getDevicePluginDetail({ id });
    store.dispatch({
      type: "setDevicePluginDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setDevicePluginDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
  }
};

// 获取产品管理详情
export const getProductManageDetail = async (
  id: string | number | undefined,
  cb?: any,
  onTampered?: (errorInfo: any) => void
) => {
  try {
    const res: any = await api.getProductManageDetail({ id });
    if (isTamperedError(undefined, res)) {
      store.dispatch({
        type: "setProductManageDetail",
        payload: null,
      });
      message.error(res?.msg || "数据完整性校验失败，数据疑似被篡改");
      if (typeof onTampered === "function") {
        onTampered(res);
      }
      return;
    }
    store.dispatch({
      type: "setProductManageDetail",
      payload: res.data,
    });
    if (cb) {
      cb();
    }
  } catch (errorInfo: any) {
    store.dispatch({
      type: "setProductManageDetail",
      payload: null,
    });
    message.error(errorInfo?.response?.data?.msg || "出错了！");
    if (isTamperedError(errorInfo) && typeof onTampered === "function") {
      onTampered(errorInfo);
    }
  }
};

/**
 * 超级设备模板管理 产品管理 内嵌的链接参数
 */
export const setEnable = (enable: string) => {
  sessionStorage.setItem("enable", enable);
};

export const getEnable = () => {
  return sessionStorage.getItem("enable");
};

// 重置表单校验
export const resetFormValidate = (value: { form: FormInstance; formValues: any }[]) => {
  value.forEach((item: { form: FormInstance; formValues: any }) => {
    console.log(item.formValues);
    item.form.resetFields();
    item.form.setFieldsValue(item.formValues); // 重置表单值，可选
  });
};

// 校验当前表格字段填写
export const validateFormField = async (value: { form: FormInstance; name: string }) => {
  try {
    await value.form.validateFields([value.name]);
    return false;
  } catch (err) {
    return true;
  }
};
// 定义固定应用类型的字面量类型（提升类型校验精度）
export type FixedAppType = "ATOMIC" | "APP" | "ACS" | "KCS" | "TOOLBOX" | "PSO";

export type AppType = FixedAppType | "CUSTOM";

// 固定应用类型数组（与字面量类型联动）
export const fixedAppType: FixedAppType[] = ["ATOMIC", "APP", "ACS", "KCS", "TOOLBOX", "PSO"];

/**
 * 判断是否为固定类型应用
 * @param type 应用类型（支持 string/number/undefined，自动转为字符串判断）
 * @returns 是否为固定类型
 */
export const isCustomTypeApp = (type: string | number | undefined): boolean => {
  if (type === undefined || type === null || type === "") return false;
  const typeStr = String(type);
  return fixedAppType.includes(typeStr as FixedAppType);
};

/**
 * 获取标准化的应用类型（非固定类型返回 'CUSTOM'）
 * @param type 应用类型（支持 string/number/undefined）
 * @returns 标准化类型（FixedAppType | "CUSTOM"）
 */
export const getType = (type: string | number | undefined): AppType => {
  if (type === undefined || type === null || type === "") return "CUSTOM";
  const typeStr = String(type);
  return fixedAppType.includes(typeStr as FixedAppType) ? (typeStr as FixedAppType) : "CUSTOM";
};
// 解析自定义json文件
export const parseResponseToArray = (str: string | undefined | null) => {
  // 场景1：空值处理（空字符串/undefined/null）
  if (!str || str.trim() === "") {
    return []; // 空值直接返回空数组，符合业务预期
  }
  try {
    // 场景2：清理JSON语法错误（多余逗号）
    const cleanStr = str.replace(/,\s*}/g, "}").replace(/,\s*]/g, "]"); // 同时处理对象/数组末尾的多余逗号
    // 场景3：解析为数组
    const result = JSON.parse(cleanStr);
    // 场景4：确保返回的是数组（防止后端返回非数组格式，如单个对象）
    return result?.config || [];
  } catch (error) {
    // 场景5：解析失败（如JSON格式错误）
    console.error("JSON解析失败：", error);
    return []; // 空值直接返回空数组，符合业务预期
  }
};

export interface GetRepeatNameExistMessageParams {
  repeatMsg: Record<string, string> | undefined;
  typeKey: string | undefined;
  appTypes: { key?: string; label?: string }[];
  nameLabel: string;
  nameAlreadyFallback: string;
}

/** 名称重复校验接口返回 exist 时的提示文案 */
export function getRepeatNameExistMessage(params: GetRepeatNameExistMessageParams): string {
  const { repeatMsg, typeKey, appTypes, nameLabel, nameAlreadyFallback } = params;
  const fromRepeatMsg = typeKey ? repeatMsg?.[typeKey] : undefined;
  if (fromRepeatMsg) {
    return fromRepeatMsg + nameLabel;
  }
  const typeLabel = appTypes.find((item) => item.key === typeKey)?.label || "";
  if (typeLabel) {
    return `您已在“${typeLabel}”中使用了该${nameLabel}`;
  }
  return nameAlreadyFallback;
}

export const KH_ACCOUNT_BASE_ENV_MAP = {
  dev: "https://devaccount.kaihong.com",
  test: "https://testaccount.kaihong.com",
  prod: "https://account.kaihong.com",
};

export const getAccountBase = () => {
  const origin = window.location.origin;

  // 新增：如果构建时指定了统一走 /account 路径的变量
  if (process.env.REACT_APP_USE_ACCOUNT_PATH === "true") {
    return origin + "/account";
  }
  // 根据当前域名动态匹配环境
  if (origin.includes("//dev")) {
    return KH_ACCOUNT_BASE_ENV_MAP.dev;
  } else if (origin.includes("//test")) {
    return KH_ACCOUNT_BASE_ENV_MAP.test;
  } else {
    // 生产环境
    return KH_ACCOUNT_BASE_ENV_MAP.prod;
  }
};

export const goLogin = () => {
  const loginUrl = `${getAccountBase()}/login`;

  // 默认回跳地址为当前页面的完整 URL
  let targetJumpUrl = window.location.href;

  // 解析当前 URL 参数
  const urlParams = new URLSearchParams(window.location.search);
  const jumpUrlParam = urlParams.get("jump_url");

  // 如果当前处于旧的 /login 路由，需要特殊处理以避免登录后跳回导致死循环
  if (window.location.pathname.endsWith("/login")) {
    if (jumpUrlParam) {
      // 场景：第三方带 jump_url 跳转到旧的 /login
      // 直接将第三方的 jump_url 传递给统一登录平台
      targetJumpUrl = decodeURIComponent(jumpUrlParam);
    } else {
      // 场景：用户直接访问了 /login
      // 登录后不应再跳回 /login，而是默认跳回项目首页
      targetJumpUrl = window.location.origin + (publicPath || "/");
    }
  }
  const encodedHref = encodeURIComponent(targetJumpUrl);
  removeAuthToken("Authorization");
  removeAuthToken("X-Access-Token");
  window.location.href = `${loginUrl}?jump_url=${encodedHref}&scope=developers`;
};
